// extracted by mini-css-extract-plugin
export default {"modalBtn":"style_modalBtn__750jG","disabledBtn":"style_disabledBtn__t5U9A","btnTitle":"style_btnTitle__waf7m"};